import { forwardRef, useEffect, useRef, useState } from 'react';
import Boto from 'components/3catinfo/Boto';
import Enllac from 'components/3catinfo/Enllac';
import __isEmpty from 'lodash/isEmpty';
import styles from './llistatPrevisioMunicipis.module.scss';
import municipisAllList from './municipis_cat.json';
import Titol from 'components/3catinfo/Titol';
import clsx from 'clsx';

const filterByProvincia = (provincia) => {
    const filteredMunicipis = municipisAllList.municipis.filter((item) => item.provincia === provincia);
    return filteredMunicipis.sort((a, b) => a.nom.localeCompare(b.nom));
};

const getProvinciaByMunicipi = (municipiId) => {
    return municipisAllList.municipis.filter((item) => parseInt(item.id) === parseInt(municipiId))?.[0]?.provincia;
};

const Municipi = forwardRef((props, publicRef) => {
    const { id, nom, visible } = props;

    const stylesMunicipi = clsx({
        [styles.contentMunicipi]: true,
        [styles.ocult]: !visible
    });

    return (
        <li className={stylesMunicipi}>
            <Enllac
                type='web_3catinfo_el_temps_municipi'
                slug={nom}
                id={id}
                className={styles.municipi}
                title={`Previsió del temps a ${nom}`}
                tabIndex={visible ? 0 : -1}
                ref={publicRef}
            >
                {nom}
            </Enllac>
        </li>
    );
});

const LlistatMunicipis = (props) => {
    const { municipis } = props;
    const itemsPage = 30;
    const totalItems = municipis?.length;
    const totalPages = Math.ceil(totalItems / itemsPage);
    const [currentPage, setCurrentPage] = useState(0);
    const [announcement, setAnnouncement] = useState('');
    const [toggleMessage, setToggleMessage] = useState(true);
    const newItemRef = useRef(null);

    const handleNext = () => {
        if (currentPage < totalPages - 1) {
            setCurrentPage((prev) => prev + 1);
            setAnnouncement(toggleMessage ? "S'ha mostrat més contingut" : "S'ha carregat més contingut");
            setToggleMessage(!toggleMessage);
            setTimeout(() => {
                setAnnouncement('');
            }, 100);
        }
    };

    useEffect(() => {
        if (currentPage > 0 && newItemRef.current) {
            newItemRef.current.focus();
        }
    }, [currentPage]);

    return !__isEmpty(municipis) ? (
        <>
            <ul className={styles.listMunicipis}>
                {municipis.map((item, index) => (
                    <Municipi
                        {...item}
                        key={`llistat-previsio-municipis-municipi-${item.id}`}
                        visible={Math.floor(index / itemsPage) <= currentPage}
                        ref={index === currentPage * itemsPage ? newItemRef : null}
                    />
                ))}
            </ul>
            {currentPage < totalPages - 1 && (
                <div className={styles.contentButtonCarregaMes}>
                    <Boto
                        tag='button'
                        text='Mostra’n més'
                        icona='fletxa_simple_avall'
                        altIcona=''
                        iconaInline='true'
                        isIconaDreta='true'
                        className={styles.carregaMes}
                        onClick={handleNext}
                    />
                </div>
            )}
            <div aria-live='assertive' className={styles.announcement}>
                {announcement}
            </div>
        </>
    ) : (
        <></>
    );
};

const LlistatPrevisioMunicipis = (props) => {
    const { routerQuery } = props;
    const provincia = !__isEmpty(routerQuery?.id) ? getProvinciaByMunicipi(routerQuery.id) : 'Barcelona';
    const [provinciaSelect, setProvinciaSelect] = useState(provincia);
    const [listMunicipisByProvincia, setListMunicipisByProvincia] = useState(filterByProvincia(provinciaSelect));

    useEffect(() => {
        setListMunicipisByProvincia(filterByProvincia(provinciaSelect));
    }, [provinciaSelect]);

    return (
        <div className={styles.contentLlistatPrevisioMunicipis}>
            <div className={styles.capcalera}>
                <div className={styles.contentTitol} data-testid='llistat-previsio-municipis'>
                    <Titol tag='h2' titol='Troba la previsió del teu municipi' estil='ambParagraf' />
                </div>
                <ul className={styles.contentButtons}>
                    <li>
                        <Boto
                            tag='button'
                            text='Barcelona'
                            className={`${styles.boto} ${provinciaSelect === 'Barcelona' ? styles.selected : ''}`}
                            ariaPressed={provinciaSelect === 'Barcelona'}
                            onClick={() => setProvinciaSelect('Barcelona')}
                        />
                    </li>
                    <li>
                        <Boto
                            tag='button'
                            text='Tarragona'
                            className={`${styles.boto} ${provinciaSelect === 'Tarragona' ? styles.selected : ''}`}
                            ariaPressed={provinciaSelect === 'Tarragona'}
                            onClick={() => setProvinciaSelect('Tarragona')}
                        />
                    </li>
                    <li>
                        <Boto
                            tag='button'
                            text='Girona'
                            className={`${styles.boto} ${provinciaSelect === 'Girona' ? styles.selected : ''}`}
                            ariaPressed={provinciaSelect === 'Girona'}
                            onClick={() => setProvinciaSelect('Girona')}
                        />
                    </li>
                    <li>
                        <Boto
                            tag='button'
                            text='Lleida'
                            className={`${styles.boto} ${provinciaSelect === 'Lleida' ? styles.selected : ''}`}
                            ariaPressed={provinciaSelect === 'Lleida'}
                            onClick={() => setProvinciaSelect('Lleida')}
                        />
                    </li>
                </ul>
            </div>
            <div className={styles.contentMunicipis}>
                <LlistatMunicipis municipis={listMunicipisByProvincia} />
            </div>
        </div>
    );
};

export default LlistatPrevisioMunicipis;

Municipi.displayName = 'Municipi';
